import React from "react";

export default function ContentFormSquelette({ children, style, className }) {
  return (
    <>
      <div className="tyn-content tyn-auth tyn-auth-centered" style={style}>
        <div className={className ? className : "container"}>{children}</div>
      </div>
    </>
  );
}
